import { render, staticRenderFns } from "./AboutClient.vue?vue&type=template&id=00289ec4&scoped=true&"
import script from "./AboutClient.vue?vue&type=script&lang=js&"
export * from "./AboutClient.vue?vue&type=script&lang=js&"
import style0 from "./AboutClient.vue?vue&type=style&index=0&id=00289ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00289ec4",
  null
  
)

export default component.exports